import { BaseService } from "./common/base";
import type { DispatchManager } from "../../../../api/src/dispatch-manager/entities/dispatch-manager.entity";

export class DispatchManagerService extends BaseService<DispatchManager> {
  constructor() {
    super("dispatch-manager");
  }
}
